let INDEX = require('file-loader?name=index.html!./build.html');
var CSS = require("./css/app.scss");

import Vue from 'vue';
import firebase from 'firebase';
import Vuefire from 'vuefire';
import VueRouter from 'vue-router';
import Vuex from 'vuex';

Vue.use(Vuefire);
Vue.use(VueRouter);
Vue.use(Vuex);

import store from './store';
import { state, mutations } from './store/state.js';
import * as Firebase from './config.js';

/* Register components */

Vue.component('app-frame', require('./App.vue'));
Vue.component('app-header', require('./components/header.vue'));
Vue.component('tabs', require('./components/tabs.vue'));
Vue.component('tab', require('./components/tab.vue'));
Vue.component('list-item', require('./components/listitem.vue'));
Vue.component('longform-editor', require('./components/longformeditor.vue'));
Vue.component('relevant-link', require('./components/relevantlink.vue'));

/* Register pages */

import Index from './pages/index.vue';
import Login from './pages/login.vue';
import NewStock from './pages/newstock.vue';
import NewNote from './pages/newnote.vue';

/* Register views */

import Dashboard from './views/dashboard.vue';
import StockView from './views/stockview.vue';
import NoteView from './views/noteview.vue';
import DesignGuide from './views/designguide.vue';

let router = new VueRouter({
  routes: [
    {
      path: '/',
      component: Index,
      children: [
        {
          path: '',
          component: Dashboard
        },{
          path: '/stock/:symbol',
          component: StockView
        },{
          path: '/note/:name',
          component: NoteView
        },{
          path: '/design',
          component: DesignGuide
        }
      ]
    },{
      path: '/login',
      component: Login,
      meta: { noAuth: true }
    },{
      path: '/new',
      component: NewStock
    },{
      path: '/stock/:symbol/edit',
      component: NewStock
    },{
      path: '/newnote',
      component: NewNote
    },{
      path: '/note/:name/edit',
      component: NewNote
    }
  ]
});

router.beforeEach((destination, origin, next) => {
  if(destination.matched.some(record => record.meta.noAuth)){
    //no auth required
    next();
  }else{
    //this route requires auth
    if(firebase.auth().currentUser){
      next();
    }else{
      //not logged in, redirect to login form
      next('/login');
    }
  }
});

Firebase.initializeFirebase().then((user) => {
  let app = new Vue({
    store,
    router
  }).$mount('#app');
});



// WEBPACK FOOTER //
// ./src/main.js